import { render, staticRenderFns } from "./user-search-select.vue?vue&type=template&id=53ca40e8&lang=pug&"
import script from "./user-search-select.vue?vue&type=script&lang=js&"
export * from "./user-search-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports